import { useDebounceWithLoading } from '@/lib/utils';

export const LIVE_SEARCH_DEBOUNCE_MS = 700;
export const LIVE_SEARCH_MIN_TEXT_LENGTH = 3;

export function hasSearchableText(text: string): boolean {
  return text.length >= LIVE_SEARCH_MIN_TEXT_LENGTH;
}

export function useLiveSearchGate<T>(params: T, isSearchable: (params: T) => boolean): { params: T; ready: boolean } {
  const { debouncedValue, isLoading } = useDebounceWithLoading(params, LIVE_SEARCH_DEBOUNCE_MS);
  return { params: debouncedValue, ready: !isLoading && isSearchable(debouncedValue) };
}
